import { render } from "./MainNavigation.vue?vue&type=template&id=2d24684a&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=2d24684a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d24684a"]])

export default __exports__